/**
 * This file is generated by `pnpm codegen` from the OpenAPI spec, DO NOT EDIT.
 */

import { makeData } from 'core/types/makeData'

import * as RequestBodyTypes from '../request-bodies/types'
import * as ResponseTypes from '../responses/types'
import * as SchemaTypes from '../schema/types'
import * as UtilityTypes from '../utilities/types'

import * as ExpectedPaymentTypes from './types'

export type LoanExpectedPaymentsGetKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  unknown,
]

export type LoanExpectedPaymentsGetResponse = ResponseTypes.ExpectedPayments

export type LoanExpectedPaymentsGetVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: void
}

export const loanExpectedPaymentsGet = makeData<
  LoanExpectedPaymentsGetResponse,
  LoanExpectedPaymentsGetKey,
  LoanExpectedPaymentsGetVariables
>({
  method: 'get',
  name: 'loanExpectedPaymentsGet',
  summary: 'Get loan expected payments',
  path: '/people/{personId}/loans/{loanId}/expected-payments',
  queryKey: ({ query, personId, loanId }) => ['people', personId, 'loans', loanId, 'expected-payments', query],
})

export type LoanChangeDueDatesSchedulePostKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  unknown,
]

export type LoanChangeDueDatesSchedulePostResponse = ResponseTypes.ChangeSchedule

export type LoanChangeDueDatesSchedulePostVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: RequestBodyTypes.DueDatesPost
  query?: void
}

export const loanChangeDueDatesSchedulePost = makeData<
  LoanChangeDueDatesSchedulePostResponse,
  LoanChangeDueDatesSchedulePostKey,
  LoanChangeDueDatesSchedulePostVariables
>({
  method: 'post',
  name: 'loanChangeDueDatesSchedulePost',
  summary: 'Change due dates schedule',
  path: '/people/{personId}/loans/{loanId}/expected-payments',
  queryKey: ({ query, personId, loanId }) => ['people', personId, 'loans', loanId, 'expected-payments', query],
})

export type DrawExpectedPaymentsGetKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'draws',
  string | undefined,
  'expected-payments',
  unknown,
]

export type DrawExpectedPaymentsGetResponse = ResponseTypes.ExpectedPayments

export type DrawExpectedPaymentsGetVariables = {
  personId: string | undefined
  loanId: string | undefined
  drawId: string | undefined
  body?: void
  query?: void
}

export const drawExpectedPaymentsGet = makeData<
  DrawExpectedPaymentsGetResponse,
  DrawExpectedPaymentsGetKey,
  DrawExpectedPaymentsGetVariables
>({
  method: 'get',
  name: 'drawExpectedPaymentsGet',
  summary: 'Get draw expected payments',
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/expected-payments',
  queryKey: ({ query, personId, loanId, drawId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'draws',
    drawId,
    'expected-payments',
    query,
  ],
})

export type DeferRemainingLocBalancesKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  'defer-remaining-balances',
  unknown,
]

export type DeferRemainingLocBalancesResponse = ExpectedPaymentTypes.DeferRemainingBalancesResponse

export type DeferRemainingLocBalancesVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: ExpectedPaymentTypes.DeferRemainingBalancesRequest
  query?: void
}

export const deferRemainingLocBalances = makeData<
  DeferRemainingLocBalancesResponse,
  DeferRemainingLocBalancesKey,
  DeferRemainingLocBalancesVariables
>({
  method: 'post',
  name: 'deferRemainingLocBalances',
  summary: 'Defer remaining balances for all active draws',
  path: '/people/{personId}/loans/{loanId}/expected-payments/defer-remaining-balances',
  queryKey: ({ query, personId, loanId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    'defer-remaining-balances',
    query,
  ],
})

export type DeferRemainingDrawBalancesKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'draws',
  string | undefined,
  'expected-payments',
  'defer-remaining-balances',
  unknown,
]

export type DeferRemainingDrawBalancesResponse = ExpectedPaymentTypes.DeferRemainingBalancesResponse

export type DeferRemainingDrawBalancesVariables = {
  personId: string | undefined
  loanId: string | undefined
  drawId: string | undefined
  body?: ExpectedPaymentTypes.DeferRemainingBalancesRequest
  query?: void
}

export const deferRemainingDrawBalances = makeData<
  DeferRemainingDrawBalancesResponse,
  DeferRemainingDrawBalancesKey,
  DeferRemainingDrawBalancesVariables
>({
  method: 'post',
  name: 'deferRemainingDrawBalances',
  summary: 'Defer remaining balances for a draw',
  path: '/people/{personId}/loans/{loanId}/draws/{drawId}/expected-payments/defer-remaining-balances',
  queryKey: ({ query, personId, loanId, drawId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'draws',
    drawId,
    'expected-payments',
    'defer-remaining-balances',
    query,
  ],
})

export type LoanExpectedPaymentsRefreshKey = [
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  'refresh',
  unknown,
]

export type LoanExpectedPaymentsRefreshResponse = ResponseTypes.ExpectedPayments

export type LoanExpectedPaymentsRefreshVariables = {
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: void
}

export const loanExpectedPaymentsRefresh = makeData<
  LoanExpectedPaymentsRefreshResponse,
  LoanExpectedPaymentsRefreshKey,
  LoanExpectedPaymentsRefreshVariables
>({
  method: 'post',
  name: 'loanExpectedPaymentsRefresh',
  summary: 'Refresh expected payments',
  path: '/people/{personId}/loans/{loanId}/expected-payments/refresh',
  queryKey: ({ query, personId, loanId }) => [
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    'refresh',
    query,
  ],
})

export type InternalLoanExpectedPaymentsGetKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  unknown,
]

export type InternalLoanExpectedPaymentsGetResponse = ResponseTypes.ExpectedPayments

export type InternalLoanExpectedPaymentsGetVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: void
}

export const internalLoanExpectedPaymentsGet = makeData<
  InternalLoanExpectedPaymentsGetResponse,
  InternalLoanExpectedPaymentsGetKey,
  InternalLoanExpectedPaymentsGetVariables
>({
  method: 'get',
  name: 'internalLoanExpectedPaymentsGet',
  summary: 'Get expected payments',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    query,
  ],
})

export type InternalLoanChangeDueDatesSchedulePostKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  unknown,
]

export type InternalLoanChangeDueDatesSchedulePostResponse = ResponseTypes.ChangeSchedule

export type InternalLoanChangeDueDatesSchedulePostVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: RequestBodyTypes.DueDatesPost
  query?: void
}

export const internalLoanChangeDueDatesSchedulePost = makeData<
  InternalLoanChangeDueDatesSchedulePostResponse,
  InternalLoanChangeDueDatesSchedulePostKey,
  InternalLoanChangeDueDatesSchedulePostVariables
>({
  method: 'post',
  name: 'internalLoanChangeDueDatesSchedulePost',
  summary: 'Change due dates schedule',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    query,
  ],
})

export type InternalLoanExpectedPaymentsGetOneKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  string | undefined,
  unknown,
]

export type InternalLoanExpectedPaymentsGetOneResponse = UtilityTypes.SingletonResponse & {
  data?: SchemaTypes.ExpectedPayment
}

export type InternalLoanExpectedPaymentsGetOneVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  expectedPaymentId: string | undefined
  body?: void
  query?: void
}

export const internalLoanExpectedPaymentsGetOne = makeData<
  InternalLoanExpectedPaymentsGetOneResponse,
  InternalLoanExpectedPaymentsGetOneKey,
  InternalLoanExpectedPaymentsGetOneVariables
>({
  method: 'get',
  name: 'internalLoanExpectedPaymentsGetOne',
  summary: 'Get expected payment by ID',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments/{expectedPaymentId}',
  queryKey: ({ query, companyId, personId, loanId, expectedPaymentId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    expectedPaymentId,
    query,
  ],
})

export type InternalLoanExpectedPaymentsRefreshKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  'refresh',
  unknown,
]

export type InternalLoanExpectedPaymentsRefreshResponse = ResponseTypes.ExpectedPayments

export type InternalLoanExpectedPaymentsRefreshVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: void
  query?: {
    isPostReplay?: boolean
  }
}

export const internalLoanExpectedPaymentsRefresh = makeData<
  InternalLoanExpectedPaymentsRefreshResponse,
  InternalLoanExpectedPaymentsRefreshKey,
  InternalLoanExpectedPaymentsRefreshVariables
>({
  method: 'post',
  name: 'internalLoanExpectedPaymentsRefresh',
  summary: 'Refresh expected payments',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments/refresh',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    'refresh',
    query,
  ],
})

export type InternalLoanExpectedPaymentOverrideKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  'override',
  unknown,
]

export type InternalLoanExpectedPaymentOverrideResponse = void

export type InternalLoanExpectedPaymentOverrideVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: {
    capitalizedAmount?: /** Amount to of the expected payment amount that was capitalized */
    string /** Amount to of the expected payment amount that was capitalized */ | null
    overpaymentAdjustmentAmount?: /** Amount to subtract from the original amount since it got paid by the depletion of the overpayment on the LOC */
    | string /** Amount to subtract from the original amount since it got paid by the depletion of the overpayment on the LOC */
      | null
    /** ID of expected payment that needs updating */
    expectedPaymentId?: string
    isDrawFee?: boolean
  }
  query?: void
}

export const internalLoanExpectedPaymentOverride = makeData<
  InternalLoanExpectedPaymentOverrideResponse,
  InternalLoanExpectedPaymentOverrideKey,
  InternalLoanExpectedPaymentOverrideVariables
>({
  method: 'put',
  name: 'internalLoanExpectedPaymentOverride',
  summary:
    'Update an expected payment. Currently used internally for only a few narrow use cases:   - updating the expected payment in the case of overpayment adjustment   - updating the expected payment to zero in the case of fee capitalization',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments/override',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    'override',
    query,
  ],
})

export type InternalLoanExpectedPaymentsOverLimitKey = [
  'companies',
  string | undefined,
  'people',
  string | undefined,
  'loans',
  string | undefined,
  'expected-payments',
  'over-limit',
  unknown,
]

export type InternalLoanExpectedPaymentsOverLimitResponse = ResponseTypes.OverLimitResponse

export type InternalLoanExpectedPaymentsOverLimitVariables = {
  companyId: string | undefined
  personId: string | undefined
  loanId: string | undefined
  body?: RequestBodyTypes.OverLimitPost
  query?: void
}

export const internalLoanExpectedPaymentsOverLimit = makeData<
  InternalLoanExpectedPaymentsOverLimitResponse,
  InternalLoanExpectedPaymentsOverLimitKey,
  InternalLoanExpectedPaymentsOverLimitVariables
>({
  method: 'post',
  name: 'internalLoanExpectedPaymentsOverLimit',
  summary: 'Create OverLimitPayment',
  path: '/companies/{companyId}/people/{personId}/loans/{loanId}/expected-payments/over-limit',
  queryKey: ({ query, companyId, personId, loanId }) => [
    'companies',
    companyId,
    'people',
    personId,
    'loans',
    loanId,
    'expected-payments',
    'over-limit',
    query,
  ],
})

export type InternalDeferRemainingLocBalancesKey = [
  'companies',
  string | undefined,
  'defer-remaining-balances',
  unknown,
]

export type InternalDeferRemainingLocBalancesResponse = ExpectedPaymentTypes.DeferRemainingBalancesResponse

export type InternalDeferRemainingLocBalancesVariables = {
  companyId: string | undefined
  body?: {
    loanId: string
    deferralType: 'capitalizeRemainingBalance'
    drawIds?: Array<string>
    dueDates?: Array<string>
    creatingMessageId?: string
  }
  query?: void
}

export const internalDeferRemainingLocBalances = makeData<
  InternalDeferRemainingLocBalancesResponse,
  InternalDeferRemainingLocBalancesKey,
  InternalDeferRemainingLocBalancesVariables
>({
  method: 'post',
  name: 'internalDeferRemainingLocBalances',
  summary: 'Worker endpoint for deferring remaining balances on replay.',
  path: '/companies/{companyId}/defer-remaining-balances',
  queryKey: ({ query, companyId }) => ['companies', companyId, 'defer-remaining-balances', query],
})
